/**
 * Щуковые — 5 видов.
 *
 * ⚠️ ПОМЕТКИ «── ГДЕ ВОДИТСЯ ──» ПЕРЕЕХАЛИ СЮДА ВМЕСТЕ С РЫБОЙ. Вторая сотня
 * набиралась по краям света, и в прежнем файле виды стояли блоками: Иберия,
 * Балканы, Восточная Азия. Разрез по семействам эти блоки разнёс бы по
 * девятнадцати файлам, и знание о том, откуда вид, пропало бы вовсе — в коде
 * его больше нигде нет. Поэтому пометка идёт за своей рыбой.
 */
export const ЩУКОВЫЕ = [
    // ── Наши воды ──
    {
        id: 'pike',
        семейство: 'щуковые',
        latin: 'Esox lucius',
        повадка: 'засадный',
        minKg: 0.4,
        maxKg: 9,
        typicalKg: 1.4,
        typicalLengthM: 0.6,
        depthM: 1.6,
        depthBandM: 1.8,
        сложение: 'округлое',
        пасть: 'костистая',
        редкость: 'нечастая',
        когда: 'дневная',
        вода: { мин: 1, опт: 15, макс: 24 },
        течение: 'слабое',
        держится: ['трава', 'коряги', 'бровка'],
        стая: 'одиночка',
        зубы: true,
        нерест: { с: 3, по: 4 },
        чем: [
            { чем: 'wobbler', вес: 1 },
            { чем: 'spoon', вес: 0.8 },
            { чем: 'живец', вес: 0.8 },
            { чем: 'jig', вес: 0.6 },
            { чем: 'spinner', вес: 0.4 },
            { чем: 'резка', вес: 0.4 },
            { чем: 'лягушка', вес: 0.2 },
        ],
        вИгре: 'pike',
    },
    {
        id: 'amur_pike',
        семейство: 'щуковые',
        latin: 'Esox reichertii',
        повадка: 'засадный',
        minKg: 0.5,
        maxKg: 16,
        typicalKg: 2,
        typicalLengthM: 0.65,
        depthM: 1.8,
        depthBandM: 1.8,
        сложение: 'округлое',
        пасть: 'костистая',
        редкость: 'обычная',
        когда: 'дневная',
        вода: { мин: 2, опт: 16, макс: 24 },
        течение: 'слабое',
        держится: ['трава', 'коряги', 'бровка'],
        стая: 'одиночка',
        зубы: true,
        нерест: { с: 4, по: 5 },
        чем: [
            { чем: 'wobbler', вес: 1 },
            { чем: 'spoon', вес: 0.8 },
            { чем: 'spinner', вес: 0.8 },
            { чем: 'jig', вес: 0.8 },
            { чем: 'живец', вес: 0.6 },
            { чем: 'резка', вес: 0.4 },
        ],
    },
    // ── Иберия и Италия ──
    {
        id: 'italian_pike',
        семейство: 'щуковые',
        latin: 'Esox cisalpinus',
        повадка: 'засадный',
        minKg: 0.5,
        maxKg: 10,
        typicalKg: 2.5,
        typicalLengthM: 0.7,
        depthM: 2,
        depthBandM: 1.5,
        сложение: 'округлое',
        пасть: 'костистая',
        редкость: 'обычная',
        когда: 'дневная',
        вода: { мин: 4, опт: 17, макс: 26 },
        течение: 'слабое',
        держится: ['трава', 'коряги', 'бровка'],
        стая: 'одиночка',
        зубы: true,
        нерест: { с: 2, по: 3 },
        чем: [
            { чем: 'wobbler', вес: 1 },
            { чем: 'spinner', вес: 0.8 },
            { чем: 'spoon', вес: 0.8 },
            { чем: 'jig', вес: 0.8 },
            { чем: 'живец', вес: 0.6 },
            { чем: 'резка', вес: 0.4 },
            { чем: 'мушка', вес: 0.2 },
        ],
    },
    // ── Западная и Северная Европа ──
    {
        id: 'aquitanian_pike',
        семейство: 'щуковые',
        latin: 'Esox aquitanicus',
        повадка: 'засадный',
        minKg: 0.4,
        maxKg: 6,
        typicalKg: 1.5,
        typicalLengthM: 0.6,
        depthM: 2,
        depthBandM: 1.5,
        сложение: 'округлое',
        пасть: 'костистая',
        редкость: 'нечастая',
        когда: 'дневная',
        вода: { мин: 3, опт: 16, макс: 25 },
        течение: 'слабое',
        держится: ['трава', 'коряги', 'бровка'],
        стая: 'одиночка',
        зубы: true,
        нерест: { с: 2, по: 4 },
        чем: [
            { чем: 'wobbler', вес: 1 },
            { чем: 'spinner', вес: 0.8 },
            { чем: 'jig', вес: 0.8 },
            { чем: 'spoon', вес: 0.6 },
            { чем: 'живец', вес: 0.6 },
            { чем: 'мушка', вес: 0.2 },
            { чем: 'резка', вес: 0.2 },
        ],
        краснокнижная: true,
    },
    // ── Северная Америка ──
    {
        id: 'muskellunge',
        семейство: 'щуковые',
        latin: 'Esox masquinongy',
        повадка: 'засадный',
        minKg: 2,
        maxKg: 20,
        typicalKg: 5,
        typicalLengthM: 1.1,
        depthM: 3,
        depthBandM: 2,
        сложение: 'округлое',
        пасть: 'костистая',
        редкость: 'редкая',
        когда: 'сумеречная',
        вода: { мин: 4, опт: 19, макс: 27 },
        течение: 'слабое',
        держится: ['трава', 'бровка', 'коряги'],
        стая: 'одиночка',
        зубы: true,
        нерест: { с: 4, по: 5 },
        чем: [
            { чем: 'wobbler', вес: 1 },
            { чем: 'spinner', вес: 1 },
            { чем: 'jig', вес: 0.8 },
            { чем: 'spoon', вес: 0.6 },
            { чем: 'живец', вес: 0.6 },
            { чем: 'мушка', вес: 0.4 },
        ],
    },
];
//# sourceMappingURL=esocids.js.map